import { render, staticRenderFns } from "./v-select.vue?vue&type=template&id=81bb76e0&scoped=true&"
import script from "./v-select.vue?vue&type=script&lang=js&"
export * from "./v-select.vue?vue&type=script&lang=js&"
import style0 from "./v-select.vue?vue&type=style&index=0&id=81bb76e0&lang=scss&scoped=true&"
import style1 from "./v-select.vue?vue&type=style&index=1&id=81bb76e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bb76e0",
  null
  
)

export default component.exports